import styled from 'styled-components';
import { COLORS, FONTS, SIZES } from '../styleVars';
var Line = styled.span.withConfig({
  componentId: "sc-ajygix-0"
})(["width:auto;margin-right:5%;margin-left:25%;height:1px;background-color:", ";"], COLORS.lighterGrey);
var List = styled.div.withConfig({
  componentId: "sc-ajygix-1"
})(["display:flex;flex-direction:row;justify-content:flex-start;align-items:center;align-content:center;height:", ";padding:", " ", ";"], SIZES['42'], SIZES['4'], SIZES['16']);
var Placeholder = styled.div.withConfig({
  componentId: "sc-ajygix-2"
})(["width:100%;display:flex;justify-content:center;padding:", " 0;background-color:", ";text-align:center;font-family:", ";font-weight:", ";font-size:", ";color:", ";"], SIZES['16'], COLORS.white, FONTS.PTSans, FONTS.regular, FONTS['12'], COLORS.darkerGrey);
export { Line, List, Placeholder };
//# sourceMappingURL=ContentStyles.js.map